document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('form').addEventListener('submit', (ev) => {
    ev.preventDefault();
    console.log("START")
    //get data from form
    const email = ev.target.elements.modal_mail.value;
    const phone = ev.target.elements.modal_phone.value
    const message = ev.target.elements.message.value + ` TELEFON: ${phone}`;
    const name = ev.target.elements.modal_name.value;

    const xhr = new XMLHttpRequest();
    xhr.open("POST", `https://api.g-group.dev/action/sendEmail`, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.setRequestHeader("x-access-token", "@o8lIF#dlI@FtdK&U@^DFi57ksf5i72kdust");
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if(xhr.response.includes("<head>")){
          window.location.replace('/admin');
        }
        if(JSON.parse(xhr.response).status == true){
          document.getElementById("email_success_message").innerText = "Message sent succesfully"
          document.getElementById("contact__name").value = ""
          document.getElementById("contact__email").value = ""
          document.getElementById("contact__phone").value = ""
          document.getElementById("contact__message").value = ""
          console.log("sending success")
        } else {
          document.getElementById("email_failure_message").innerText = "Message delivery failed, please try again or contact us by phone"
          console.log("sending failed")
        }
      }
    }
    xhr.send(JSON.stringify({
      message: message,
      modal_email: email,
      modal_name: name
    }));
  })
})
